const setup_chart_controller = function($scope, chartFilters, service_api, method_name) {
    const service_method = service_api[method_name];
    const apply_chart_filters = function(model) {
        return service_method(model).then(rows => $scope.rows = rows);
    };
    apply_chart_filters(chartFilters.get_chart_filters());
    chartFilters.onChangeChartParams('do_' + method_name, apply_chart_filters);
    $scope.rows = [];
};

const main_view = {
    template: require('./view.html'),
    controller: [
        '$scope',
        'economics_api',
        'chartFilters',
        function($scope, economics_api, chartFilters) {
            return setup_chart_controller($scope, chartFilters, economics_api, 'campaign_installs_table');
        },
    ],
};
export default {
    url: '/campaign_installs',
    reloadOnSearch: false,
    data: {
        priority: 803,
        title: 'Progress By Days Cohorts',
    },
    views: {
        '': main_view,
    },
};
